export default "__VITE_ASSET__d06a2d9e__"